import { Directive, Input, HostListener } from '@angular/core';

@Directive({
  selector: '[onlyNumbers]'
})
export class OnlyNumbersDirective {
  @Input() condition: boolean = false;

  @HostListener('input', ['$event'])
  onInput(event: any) {
    if (this.condition) {
      const input = event.target.value;
      event.target.value = input.replace(/[^0-9]/g, '');
    }
  }
}
